import { makeStyles } from "@material-ui/core/styles";
import { getSafeOrDefault } from "../../../util/object-util";
import Grass from "../../../assets/images/grass-pattern@2x.png";
import PositionIcon from "../../../assets/images/ball-position-border@1x.svg";

const ballPositionStyles = makeStyles((theme) => ({
	fieldBar: {
		height: 8,
		backgroundImage: `url(${Grass})`,
		backgroundRepeat: "repeat-x",
		margin: theme.spacing(0, 0.25)
	},
	zoneBar: {
		height: 4,
		backgroundColor: ({ homeTeam }) =>
			getSafeOrDefault(() => homeTeam.color, theme.palette.teams.home),
		margin: theme.spacing(0, 0.25),
		"&.visitor": {
			backgroundColor: ({ awayTeam }) =>
				getSafeOrDefault(() => awayTeam.color, theme.palette.teams.visitor)
		}
	},
	zoneBarText: { fontSize: 16 },
	zoneBarMiddleText: {
		fontSize: 24
	},
	endZoneBar: {
		height: 12,
		backgroundColor: ({ homeTeam }) =>
			getSafeOrDefault(() => homeTeam.color, theme.palette.teams.home),
		margin: theme.spacing(0, 0.25),
		borderRadius: theme.spacing(0, 0.25, 0.25, 0),
		"&.visitor": {
			backgroundColor: ({ awayTeam }) =>
				getSafeOrDefault(() => awayTeam.color, theme.palette.teams.visitor),
			borderRadius: theme.spacing(0.25, 0, 0, 0.25)
		}
	},
	endZoneText: {
		fontSize: 12,
		textTransform: "uppercase",
		color: ({ homeTeam }) =>
			getSafeOrDefault(() => homeTeam.color, theme.palette.teams.home),
		"&.visitor": {
			color: ({ awayTeam }) =>
				getSafeOrDefault(() => awayTeam.color, theme.palette.teams.visitor)
		}
	},
	ballPosition: {
		marginLeft: -15,
		paddingLeft: ({ offset }) => offset && offset.current,
		color: theme.palette.menu.item.active.backgroundColor
	},
	positionText: {
		backgroundImage: `url(${PositionIcon})`,
		backgroundSize: "cover",
		backgroundRepeat: "no-repeat",
		height: 47,
		width: 38,
		display: "inline-block",
		padding: 2,
		fontFamily: "Barlow Condensed",
		fontWeight: "bold",
		textAlign: "center"
	},
	slideEnter: {
		paddingLeft: ({ offset }) => offset && offset.previous,
		color: "transparent"
	},
	slideEnterActive: {
		color: theme.palette.menu.item.active.backgroundColor,
		paddingLeft: ({ offset }) => offset && offset.current,
		transition: "padding-left 1000ms, color 1000ms ease-in-out"
	},
	"@media (prefers-reduced-motion: reduce)": {
		slideEnterActive: {
			transition: "none"
		}
	},
	positionGrid: {
		height: "calc(100% - 4px)",
		lineHeight: ({ subtitle }) => (subtitle || subtitle === 0) && "normal"
	},
	fieldOverlayWrapper: {
		position: "relative"
	},
	markerOverlay: {
		position: "absolute",
		top: 0,
		bottom: 0,
		left: 0,
		right: 0,
		pointerEvents: "none"
	},
	areaBand: {
		position: "absolute",
		top: 0,
		bottom: 0
	},
	firstDownLine: {
		position: "absolute",
		top: 0,
		bottom: 0,
		width: 0,
		borderLeft: `2px dashed ${theme.palette.menu.item.active.backgroundColor}`
	}
}));

export default ballPositionStyles;
